import {Button, Checkbox, Modal, message} from "antd";
import {useEffect, useState} from "react";

interface RecoveryCodesContentProps {
  codes: string[];
  onDone: () => void;
}

export function RecoveryCodesContent({codes, onDone}: RecoveryCodesContentProps) {
  const [confirmed, setConfirmed] = useState(false);

  useEffect(() => {
    setConfirmed(false);
  }, [codes]);

  const handleDownload = () => {
    const url = window.URL.createObjectURL(
      new Blob([codes.join("\n")], {type: "text/plain"})
    );
    const a = document.createElement("a");
    a.href = url;
    a.setAttribute("download", "coachli-recovery-codes.txt");
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };

  const handleCopyAll = () => {
    navigator.clipboard.writeText(codes.join("\n"));
    message.success("Recovery codes copied to clipboard");
  };

  return (
    <>
      <h3>Recovery codes</h3>
      <p>
        Use these one-time codes to verify it&apos;s you when you can&apos;t reach your
        authenticator app
      </p>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "6px 48px",
          margin: "16px 0",
          background: "#FAFAFA",
          borderRadius: 8,
          border: 4,
          borderColor: "#F0F0F0",
          padding: "16px",
        }}
      >
        {codes.map((code) => (
          <span key={code} style={{fontFamily: "monospace", fontSize: 15}}>
            {code}
          </span>
        ))}
      </div>

      <div
        style={{
          background: "#FFFBE6",
          border: "1px solid #FFE58F",
          borderRadius: 4,
          padding: "10px 14px",
          marginBottom: 16,
        }}
      >
        Save these codes somewhere safe. You&apos;ll only see them this once
      </div>

      <div style={{display: "flex", gap: "12px", width: "100%", marginBottom: 12}}>
        <Button size="small" style={{flex: 1}} onClick={handleDownload}>
          Download
        </Button>
        <Button size="small" style={{flex: 1}} onClick={handleCopyAll}>
          Copy
        </Button>
      </div>

      <Checkbox checked={confirmed} onChange={(e) => setConfirmed(e.target.checked)}>
        Yes, I have saved these codes in a safe place
      </Checkbox>

      <Button
        size="small"
        type="primary"
        block
        disabled={!confirmed}
        onClick={onDone}
        style={{marginTop: 12}}
      >
        Done
      </Button>
    </>
  );
}

interface RecoveryCodesModalProps {
  visible: boolean;
  codes: string[];
  onClose: () => void;
}

export function RecoveryCodesModal({visible, codes, onClose}: RecoveryCodesModalProps) {
  return (
    <Modal
      title="Two factor authentication"
      open={visible}
      onCancel={onClose}
      footer={null}
      closable
      centered
      width={520}
      bodyStyle={{padding: 16}}
    >
      <RecoveryCodesContent codes={codes} onDone={onClose} />
    </Modal>
  );
}
